"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
exports.__esModule = true;
exports.visitOpenAPIObjects = void 0;
var json_pointer_1 = require("@criteria/json-pointer");
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isArray(value) {
    return typeof value === 'object' && value !== null && Array.isArray(value);
}
function appendJSONPointer(path, jsonPointer) {
    return __spreadArray(__spreadArray([], __read(path.slice(0, -1)), false), ["".concat(path[path.length - 1]).concat(jsonPointer)], false);
}
function isReference(value) {
    if (typeof value !== 'object') {
        return false;
    }
    var $ref = value.$ref, summary = value.summary, description = value.description, rest = __rest(value, ["$ref", "summary", "description"]);
    return typeof $ref === 'string' && Object.keys(rest).length === 0;
}
function visitOpenAPIObjects(rootObject, rootObjectType, initialState, visitor) {
    // detects circular references
    var seen = new WeakSet();
    var visitMap = function (map, path, states, visitor) {
        var e_1, _a;
        if (!isObject(map)) {
            return false;
        }
        try {
            for (var _b = __values(Object.entries(map)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                var stop = Boolean(visitor(value, appendJSONPointer(path, "/".concat((0, json_pointer_1.escapeReferenceToken)(key))), states));
                if (stop) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    var visitList = function (list, path, states, visitor) {
        if (!isArray(list)) {
            return false;
        }
        for (var index = 0; index < list.length; index++) {
            var stop = Boolean(visitor(list[index], appendJSONPointer(path, "/".concat(index)), states));
            if (stop) {
                return true;
            }
        }
        return false;
    };
    var visitOpenAPI = function (openapi, path, states) {
        if (!isObject(openapi)) {
            return false;
        }
        var stop = false;
        if (!stop && openapi.paths) {
            stop = visitPaths(openapi.paths, states);
        }
        if (!stop && openapi.webhooks) {
            stop = visitMap(openapi.webhooks, ['/webhooks'], states, visitPathItem);
        }
        if (!stop && openapi.components) {
            stop = visitComponents(openapi.components, __spreadArray(__spreadArray([], __read(path), false), ['/components'], false), states);
        }
        return stop;
    };
    var visitPaths = function (paths, states) {
        var e_2, _a;
        if (!isObject(paths)) {
            return false;
        }
        var stop = false;
        try {
            for (var _b = __values(Object.entries(paths)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], pathItem = _d[1];
                if (key.startsWith('/')) {
                    stop = visitPathItem(pathItem, ["/paths/".concat((0, json_pointer_1.escapeReferenceToken)(key))], states);
                    if (stop) {
                        return true;
                    }
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return stop;
    };
    var visitPathItem = function (pathItem, path, states) {
        if (!isObject(pathItem)) {
            return false;
        }
        if (seen.has(pathItem)) {
            return false;
        }
        seen.add(pathItem);
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        var stop = Boolean(visitor('pathItem', pathItem, path, newState));
        if (stop) {
            return true;
        }
        if (isReference(pathItem)) {
            return false;
        }
        if (!stop && pathItem.$ref && typeof pathItem.$ref === 'object') {
            stop = visitPathItem(pathItem.$ref, __spreadArray(__spreadArray([], __read(path), false), ['/$ref'], false), states);
        }
        if (!stop && pathItem.get) {
            stop = visitOperation(pathItem.get, __spreadArray(__spreadArray([], __read(path), false), ['/get'], false), states);
        }
        if (!stop && pathItem.put) {
            stop = visitOperation(pathItem.put, __spreadArray(__spreadArray([], __read(path), false), ['/put'], false), states);
        }
        if (!stop && pathItem.post) {
            stop = visitOperation(pathItem.post, __spreadArray(__spreadArray([], __read(path), false), ['/post'], false), states);
        }
        if (!stop && pathItem["delete"]) {
            stop = visitOperation(pathItem["delete"], __spreadArray(__spreadArray([], __read(path), false), ['/delete'], false), states);
        }
        if (!stop && pathItem.options) {
            stop = visitOperation(pathItem.options, __spreadArray(__spreadArray([], __read(path), false), ['/options'], false), states);
        }
        if (!stop && pathItem.head) {
            stop = visitOperation(pathItem.head, __spreadArray(__spreadArray([], __read(path), false), ['/head'], false), states);
        }
        if (!stop && pathItem.patch) {
            stop = visitOperation(pathItem.patch, __spreadArray(__spreadArray([], __read(path), false), ['/patch'], false), states);
        }
        if (!stop && pathItem.trace) {
            stop = visitOperation(pathItem.trace, __spreadArray(__spreadArray([], __read(path), false), ['/trace'], false), states);
        }
        if (!stop && pathItem.parameters) {
            stop = visitList(pathItem.parameters, __spreadArray(__spreadArray([], __read(path), false), ['/parameters'], false), states, visitParameter);
        }
        return stop;
    };
    var visitOperation = function (operation, path, states) {
        if (!isObject(operation)) {
            return false;
        }
        if (seen.has(operation)) {
            return false;
        }
        seen.add(operation);
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        var stop = Boolean(visitor('operation', operation, path, newState));
        if (stop) {
            return true;
        }
        if (isReference(operation)) {
            return false;
        }
        if (!stop && operation.parameters) {
            stop = visitList(operation.parameters, __spreadArray(__spreadArray([], __read(path), false), ['/parameters'], false), states, visitParameter);
        }
        if (!stop && operation.requestBody) {
            stop = visitRequestBody(operation.requestBody, __spreadArray(__spreadArray([], __read(path), false), ['/requestBody'], false), states);
        }
        if (!stop && operation.responses) {
            stop = visitMap(operation.responses, __spreadArray(__spreadArray([], __read(path), false), ['/responses'], false), states, visitResponse);
        }
        if (!stop && operation.callbacks) {
            stop = visitMap(operation.callbacks, ['/callbacks'], states, visitPathItem);
        }
        return stop;
    };
    var visitSchema = function (schema, path, states) {
        if (!isObject(schema) && typeof schema !== 'boolean') {
            return false;
        }
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        if (typeof schema === 'boolean') {
            return Boolean(visitor('schema', schema, path, newState));
        }
        if (seen.has(schema)) {
            return false;
        }
        seen.add(schema);
        var stop = Boolean(visitor('schema', schema, path, newState));
        if (stop) {
            return true;
        }
        if (isReference(schema)) {
            return false;
        }
        // visit JSON Schema
        return stop;
    };
    var visitResponse = function (response, path, states) {
        if (!isObject(response)) {
            return false;
        }
        if (seen.has(response)) {
            return false;
        }
        seen.add(response);
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        var stop = Boolean(visitor('response', response, path, newState));
        if (stop) {
            return true;
        }
        if (isReference(response)) {
            return false;
        }
        if (!stop && response.headers) {
            stop = visitMap(response.headers, __spreadArray(__spreadArray([], __read(path), false), ['/headers'], false), states, visitHeader);
        }
        if (!stop && response.content) {
            stop = visitMap(response.content, __spreadArray(__spreadArray([], __read(path), false), ['/content'], false), states, visitMediaType);
        }
        if (!stop && response.links) {
            stop = visitMap(response.links, __spreadArray(__spreadArray([], __read(path), false), ['/links'], false), states, visitLink);
        }
        return stop;
    };
    var visitParameter = function (parameter, path, states) {
        if (!isObject(parameter)) {
            return false;
        }
        if (seen.has(parameter)) {
            return false;
        }
        seen.add(parameter);
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        var stop = Boolean(visitor('parameter', parameter, path, newState));
        if (stop) {
            return true;
        }
        if (isReference(parameter)) {
            return false;
        }
        if (!stop && parameter.schema !== undefined) {
            stop = visitSchema(parameter.schema, __spreadArray(__spreadArray([], __read(path), false), ['/schema'], false), states);
        }
        if (!stop && parameter.examples) {
            stop = visitMap(parameter.examples, __spreadArray(__spreadArray([], __read(path), false), ['/examples'], false), states, visitExample);
        }
        if (!stop && parameter.content) {
            stop = visitMap(parameter.content, __spreadArray(__spreadArray([], __read(path), false), ['/content'], false), states, visitMediaType);
        }
        return stop;
    };
    var visitExample = function (example, path, states) {
        if (!isObject(example)) {
            return false;
        }
        if (seen.has(example)) {
            return false;
        }
        seen.add(example);
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        var stop = Boolean(visitor('example', example, path, newState));
        if (stop) {
            return true;
        }
        return stop;
    };
    var visitRequestBody = function (requestBody, path, states) {
        if (!isObject(requestBody)) {
            return false;
        }
        if (seen.has(requestBody)) {
            return false;
        }
        seen.add(requestBody);
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        var stop = Boolean(visitor('requestBody', requestBody, path, newState));
        if (stop) {
            return true;
        }
        if (isReference(requestBody)) {
            return false;
        }
        if (!stop && requestBody.content) {
            stop = visitMap(requestBody.content, __spreadArray(__spreadArray([], __read(path), false), ['/content'], false), states, visitMediaType);
        }
        return stop;
    };
    var visitHeader = function (header, path, states) {
        if (!isObject(header)) {
            return false;
        }
        if (seen.has(header)) {
            return false;
        }
        seen.add(header);
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        var stop = Boolean(visitor('header', header, path, newState));
        if (stop) {
            return true;
        }
        if (isReference(header)) {
            return false;
        }
        if (!stop && header.schema !== undefined) {
            stop = visitSchema(header.schema, __spreadArray(__spreadArray([], __read(path), false), ['/schema'], false), states);
        }
        if (!stop && header.examples) {
            stop = visitMap(header.examples, __spreadArray(__spreadArray([], __read(path), false), ['/examples'], false), states, visitExample);
        }
        if (!stop && header.content) {
            stop = visitMap(header.content, __spreadArray(__spreadArray([], __read(path), false), ['/content'], false), states, visitMediaType);
        }
        return stop;
    };
    var visitSecurityScheme = function (securityScheme, path, states) {
        if (!isObject(securityScheme)) {
            return false;
        }
        if (seen.has(securityScheme)) {
            return false;
        }
        seen.add(securityScheme);
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        var stop = Boolean(visitor('securityScheme', securityScheme, path, newState));
        if (stop) {
            return true;
        }
        return stop;
    };
    var visitLink = function (link, path, states) {
        if (!isObject(link)) {
            return false;
        }
        if (seen.has(link)) {
            return false;
        }
        seen.add(link);
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        var stop = Boolean(visitor('link', link, path, newState));
        if (stop) {
            return true;
        }
        return stop;
    };
    var visitCallback = function (callback, path, states) {
        var e_3, _a;
        if (!isObject(callback)) {
            return false;
        }
        if (seen.has(callback)) {
            return false;
        }
        seen.add(callback);
        var newState = __assign({}, states[states.length - 1]);
        states = __spreadArray(__spreadArray([], __read(states), false), [newState], false);
        var stop = Boolean(visitor('callback', callback, path, newState));
        if (stop) {
            return true;
        }
        if (isReference(callback)) {
            return false;
        }
        try {
            for (var _b = __values(Object.entries(callback)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], pathItem = _d[1];
                if (key.startsWith('/')) {
                    stop = visitPathItem(pathItem, __spreadArray(__spreadArray([], __read(path), false), ["/".concat((0, json_pointer_1.escapeReferenceToken)(key))], false), states);
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return stop;
    };
    var visitComponents = function (components, path, states) {
        if (!isObject(components)) {
            return false;
        }
        var stop = false;
        if (!stop && components.schemas) {
            stop = visitMap(components.schemas, __spreadArray(__spreadArray([], __read(path), false), ['/schemas'], false), states, visitSchema);
        }
        if (!stop && components.responses) {
            stop = visitMap(components.responses, __spreadArray(__spreadArray([], __read(path), false), ['/responses'], false), states, visitResponse);
        }
        if (!stop && components.parameters) {
            stop = visitMap(components.parameters, __spreadArray(__spreadArray([], __read(path), false), ['/parameters'], false), states, visitParameter);
        }
        if (!stop && components.examples) {
            stop = visitMap(components.examples, __spreadArray(__spreadArray([], __read(path), false), ['/examples'], false), states, visitExample);
        }
        if (!stop && components.requestBodies) {
            stop = visitMap(components.requestBodies, __spreadArray(__spreadArray([], __read(path), false), ['/requestBodies'], false), states, visitRequestBody);
        }
        if (!stop && components.headers) {
            stop = visitMap(components.headers, __spreadArray(__spreadArray([], __read(path), false), ['/headers'], false), states, visitHeader);
        }
        if (!stop && components.securitySchemes) {
            stop = visitMap(components.securitySchemes, __spreadArray(__spreadArray([], __read(path), false), ['/securitySchemes'], false), states, visitSecurityScheme);
        }
        if (!stop && components.links) {
            stop = visitMap(components.links, __spreadArray(__spreadArray([], __read(path), false), ['/links'], false), states, visitLink);
        }
        if (!stop && components.callbacks) {
            stop = visitMap(components.callbacks, __spreadArray(__spreadArray([], __read(path), false), ['/callbacks'], false), states, visitCallback);
        }
        if (!stop && components.pathItems) {
            stop = visitMap(components.pathItems, __spreadArray(__spreadArray([], __read(path), false), ['/pathItems'], false), states, visitPathItem);
        }
        return stop;
    };
    var visitMediaType = function (mediaType, path, states) {
        if (!isObject(mediaType)) {
            return false;
        }
        var stop = false;
        if (!stop && mediaType.encoding) {
            stop = visitMap(mediaType.encoding, __spreadArray(__spreadArray([], __read(path), false), ['/encoding'], false), states, visitEncoding);
        }
        if (!stop && mediaType.examples) {
            stop = visitMap(mediaType.examples, __spreadArray(__spreadArray([], __read(path), false), ['/examples'], false), states, visitExample);
        }
        if (!stop && mediaType.schema !== undefined) {
            stop = visitSchema(mediaType.schema, __spreadArray(__spreadArray([], __read(path), false), ['/schema'], false), states);
        }
        return stop;
    };
    var visitEncoding = function (encoding, path, states) {
        if (!isObject(encoding)) {
            return false;
        }
        var stop = false;
        if (!stop && encoding.headers) {
            stop = visitMap(encoding.headers, __spreadArray(__spreadArray([], __read(path), false), ['/headers'], false), states, visitHeader);
        }
        return stop;
    };
    switch (rootObjectType) {
        case 'openapi':
            return visitOpenAPI(rootObject, [''], [initialState]);
        case 'operation':
            return visitOperation(rootObject, [''], [initialState]);
        case 'schema':
            return visitSchema(rootObject, [''], [initialState]);
        case 'response':
            return visitResponse(rootObject, [''], [initialState]);
        case 'parameter':
            return visitParameter(rootObject, [''], [initialState]);
        case 'example':
            return visitExample(rootObject, [''], [initialState]);
        case 'requestBody':
            return visitRequestBody(rootObject, [''], [initialState]);
        case 'header':
            return visitHeader(rootObject, [''], [initialState]);
        case 'securityScheme':
            return visitSecurityScheme(rootObject, [''], [initialState]);
        case 'link':
            return visitLink(rootObject, [''], [initialState]);
        case 'callback':
            return visitCallback(rootObject, [''], [initialState]);
        case 'pathItem':
            return visitPathItem(rootObject, [''], [initialState]);
        default:
            var _ = rootObjectType;
    }
}
exports.visitOpenAPIObjects = visitOpenAPIObjects;
